// Група інверторів під КТП: лічильник, ряд міні-інверторів і символ масиву
// панелей. Компактне представлення замість окремої картки на кожен інвертор.
import i18n from '@/i18n';
import { scada, stateColor } from '@/scada/tokens';
import InverterNode from './InverterNode';
import type { SchemeGroup, SchemeSelection } from './types';

/** Символ фотомодулів — сітка комірок під нахилом, без растрових картинок. */
function SolarArray({ color, dim }: { color: string; dim: boolean }) {
  const cols = 4;
  const rows = 2;
  return (
    <svg width="100%" height="26" viewBox="0 0 64 26" preserveAspectRatio="none" aria-hidden="true">
      <g opacity={dim ? 0.35 : 1}>
        {Array.from({ length: rows }).map((_, r) =>
          Array.from({ length: cols }).map((_, c) => (
            <rect key={`${r}-${c}`}
              x={2 + c * 15.5} y={2 + r * 11} width={14} height={10} rx={1}
              fill={`${color}22`} stroke={`${color}66`} strokeWidth={0.8}
              vectorEffect="non-scaling-stroke" />
          )),
        )}
      </g>
    </svg>
  );
}

/** Скільки міні-іконок показуємо до згортання в «…». */
const MAX_ICONS = 6;

export default function InverterGroup({ group, selection, onSelectInverter }: {
  group: SchemeGroup;
  selection: SchemeSelection;
  onSelectInverter: (inverterId: string) => void;
}) {
  const c = stateColor(group.state);
  const dim = group.state === 'offline';
  const shown = group.inverters.slice(0, MAX_ICONS);
  const hidden = group.inverters.length - shown.length;

  return (
    <div style={{
      background: scada.panel, border: `1px solid ${group.state === 'ok' ? scada.border : `${c}55`}`,
      borderRadius: 9, padding: '8px 8px 7px', display: 'grid', gap: 7, minWidth: 0,
    }}>
      <div className="flex items-center" style={{ gap: 5, minWidth: 0 }}>
        <span style={{ width: 6, height: 6, borderRadius: 999, background: c, flexShrink: 0 }} />
        <span style={{ fontSize: 10.5, color: scada.textDim, whiteSpace: 'nowrap',
          overflow: 'hidden', textOverflow: 'ellipsis' }}>{group.label}</span>
      </div>

      <div className="font-display tabular-nums" style={{
        fontSize: 13, fontWeight: 600,
        color: group.working < group.total ? c : scada.text, lineHeight: 1,
      }}>
        {group.working}/{group.total}
      </div>

      <div className="flex items-center" style={{ gap: 3, minWidth: 0 }}>
        {shown.map((inv) => (
          <InverterNode
            key={inv.id}
            inv={inv}
            selected={selection.kind === 'inverter' && selection.inverterId === inv.id}
            onSelect={() => onSelectInverter(inv.id)}
          />
        ))}
        {hidden > 0 && (
          <span title={i18n.t('ak_scada2_more', { n: hidden })} style={{ fontSize: 11, color: scada.textMuted, marginLeft: 1 }}>…</span>
        )}
      </div>

      <SolarArray color={c} dim={dim} />
    </div>
  );
}
